import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card m-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_5 = { class: "card-text fs-6 text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCarousel = _resolveComponent("ProductCarousel")!
  const _component_StartRating = _resolveComponent("StartRating")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ProductCarousel, { restorant: _ctx.restorant }, null, 8, ["restorant"]),
    _createVNode(_component_router_link, {
      to: { name: 'restorantdetails', params: { id: _ctx.restorant.id } },
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("div", {
          class: "card-body",
          role: "button",
          onClick: navigate
        }, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.restorant.name), 1),
          _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.restorant.timeToServe) + " minutes", 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.restorant.description), 1),
          _hoisted_6,
          _createVNode(_component_StartRating, {
            totalReviews: _ctx.restorant.totalReviews,
            rate: _ctx.restorant.rate
          }, null, 8, ["totalReviews", "rate"])
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}